import styled from 'styled-components';
const Wrapper = styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "sc-1yn1lv9-0"
})(["width:100%;display:flex;flex:1;"]);
const InnerWrapper = styled.div.withConfig({
  displayName: "style__InnerWrapper",
  componentId: "sc-1yn1lv9-1"
})(["width:100%;flex:1;flex-direction:column;display:flex;"]);
export { Wrapper, InnerWrapper };